module.exports = __webpack_public_path__ + "img/autoCheck.37d1141c.gif";